module.exports = __webpack_public_path__ + "static/img/pc01.bf5a41d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/1yuan/pc01.png
// module id = 7hBm
// module chunks = 1